<template>
	<ui-modal-template>
		<template v-slot:header>
			<div class="px-6 py-4">
				<div class="flex flex-col sm:flex-row sm:pr-4 sm:mr-6">
					<div
						class="mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full sm:mx-0 bg-red-100 mb-3 sm:mr-3"
					>
						<ui-icon
							name="alert-triangle"
							class="h-8 w-8 text-red-600"
							stroke-width="2"
						/>
					</div>
					<div class="px-3">
						<h3 class="text-2xl text-black text-center sm:text-left font-semibold">
							{{ __("Preisquelle löschen") }}
						</h3>
						<p class="mt-2 text-center sm:text-left">
							{{ __("Soll die Preisquelle wirklich gelöscht werden?") }}
						</p>
					</div>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5 hidden sm:inline-block"
					@click="$bus.$emit('modal:close')"
				>
					<ui-icon class="h-9 w-9" name="x" stroke-width="2" />
				</ui-button>
			</div>
		</template>

		<template v-slot:content>
			<form
				class="pb-6 px-6 flex flex-col flex-col-reverse sm:flex-row justify-end gap-y-3 gap-x-3"
			>
				<ui-button
					type="secondary"
					class="w-full sm:w-auto text-lg"
					@click="$bus.$emit('modal:close')"
				>{{ __("Abbrechen") }}</ui-button>

				<ui-button
					type="primary"
					class="w-full sm:w-auto text-lg bg-red-500 hover:bg-red-600"
					:disabled="loading"
					@click="submitForm()"
				>{{ __("Löschen") }}</ui-button>
			</form>
		</template>
	</ui-modal-template>
</template>

<script>

export default {
	props: {
		id: {
			type: Number,
			required: true,
		},
	},

	data() {
		return {
			loading: false,
		};
	},

	methods: {
		/**
		 * @return {void}
		 */
		submitForm() {
			this.loading = true;

			axios
				.delete(this.$route("admin.price_sources.delete", { id: this.id }))
				.then(this.onSuccess)
				.catch(this.onError)
				.finally(() => {
					this.loading = false;
				});
		},

		/**
		 * @return {void}
		 */
		onSuccess() {
			this.$bus.$emit("modal:close");
			this.$bus.$emit("content:load");
		},

		/**
		 * @param {Error} error
		 * @return {void}
		 */
		onError(error) {
			if (error.response?.status === 409) {
				this.$bus.$emit("toast", { type: "error", message: error.response.data.message });
			} else {
				this.$bus.$emit("modal:error", error);
			}
		},
	},
};
</script>
